/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: clients
 * Page name:
 * Page Description:
*/

import React from 'react'
import Carousel from "react-multi-carousel";
import 'react-multi-carousel/lib/styles.css';
import { Image } from 'react-bootstrap'
import { Row, Col } from "reactstrap";

import Vtech from "assets/images/Clients/PNG/Vtech.png"
import Ibbani from "assets/images/Clients/PNG/Ibbani.png"
import Vaml from "assets/images/Clients/PNG/Vaml.png"
import Vfb from "assets/images/Clients/PNG/Vfb.png"

import Kipl from "assets/images/Clients/PNG/Kipl.png"
import Sgb from "assets/images/Clients/PNG/Sgb.png"
import Sumukha from "assets/images/Clients/PNG/Sumukha.png"
import Techno from "assets/images/Clients/PNG/Techno.png"

import Uahs from "assets/images/Clients/PNG/Uahs.png"
import Nes from "assets/images/Clients/PNG/Nes.png"
import Jnnce from "assets/images/Clients/PNG/Jnnce.png"
import Gfgc from "assets/images/Clients/PNG/Gfgc.png"

import Vishwa from "assets/images/Clients/PNG/Vishwa.png"
import Amst from "assets/images/Clients/PNG/Amst.png"
import Clinical from "assets/images/Clients/PNG/Clinical.png"
import Glwc from "assets/images/Clients/PNG/Glwc.png"

import Supari from "assets/images/Clients/PNG/Supari.png"
import Malnadkitchen from "assets/images/Clients/PNG/Malnadkitchen.png"
import MrMillet from "assets/images/Clients/PNG/MrMillet.jpeg"
import Rootsgoods from "assets/images/Clients/PNG/Rootsgoods.png"

import Nano from "assets/images/Clients/PNG/Nano.png"
import Arshiraj from "assets/images/Clients/PNG/Arshiraj.png"
import Benz from "assets/images/Clients/PNG/Benz.png"
import Church from "assets/images/Clients/PNG/Church.png"

import Monica from "assets/images/Clients/PNG/Monica.png"
import Pgp from "assets/images/Clients/PNG/Pgp.png"
import Scholar from "assets/images/Clients/PNG/Scholar.png"
import Cedlabs from "assets/images/Clients/PNG/Cedlabs.png"

const responsive = {
  superLargeDesktop: {

    breakpoint: { max: 4000, min: 3000 },
    items: 1
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};

function Clients() {


  return (
  <div>
    <div className='embedded_listdisplay1'>
    <Carousel
    className='carouselBorder'
    autoPlay={true}
    responsive={responsive}
    infinite={true}
    autoPlaySpeed={2000}>

    <Row>

    <Col className='center'>
    <Image img src={Vtech} alt="V-Tech Engineers Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Ibbani} alt="Ibbani Food Industries Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Vaml} alt="V-Tech Automotors Limited Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Vfb} alt="V-Tech Food and Beverages Logo" className='homepageclients_techimage' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Kipl} alt="Kuntvalli Industries Private Limited Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Sgb} alt="Sri Gowri Bhargava Private Limited Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Sumukha} alt="Sumuka Steels Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Techno} alt="Techno Rings Logo" className='homepageclients_techimage' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Uahs} alt="University of Agriculture and Horticulture Sciences Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Nes} alt="National Education Society Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Jnnce} alt="JNN College of Engineering Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Gfgc} alt="Government First Grade College Logo" className='homepageclients_techimage' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Vishwa} alt="Vishwabhushana Trust Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Amst} alt="AMST Conference Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Clinical} alt="Veterinary college Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Glwc} alt="Rajya Sarkari Padavi Collegegala Atithi Upanyasakara Hitarakshana Samithi Logo" className='homepageclients_techimage' />
    </Col>

    </Row>

    <Row>

    <Col className='center'>
    <Image img src={Supari} alt="Natural Supari Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Malnadkitchen} alt="Malnad Kitchen Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={MrMillet} alt="Mr Millet Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Rootsgoods} alt="RootsGoods Logo" className='homepageclients_techimage' />
    </Col>

    </Row>


    <Row>

    <Col className='center'>
    <Image img src={Nano} alt="Nano Source Technologies Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Arshiraj} alt="Aashiraj Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Benz} alt="Mercedes Benz Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Church} alt="St Thomas Church Logo" className='homepageclients_techimage' />
    </Col>

    </Row>


    <Row>

    <Col className='center'>
    <Image img src={Monica} alt="Monica Kulkarni Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Pgp} alt="PG Prashanth Physics Channel Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Scholar} alt="Scholar Monk Foundation Logo" className='homepageclients_techimage' />
    </Col>

    <Col className='center'>
    <Image img src={Cedlabs} alt="CED Labs Logo" className='homepageclients_techimage' />
    </Col>

    </Row>



    </Carousel>
    </div>

    <div className='embedded_listdisplay2'>
      <Carousel responsive={responsive}>


          <Image img src={Vtech} alt="V-Tech Engineers Logo" className='embedded_techimg' />
          <Image img src={Ibbani} alt="Ibbani Food Industries Logo" className='embedded_techimg' />
          <Image img src={Vaml} alt="V-Tech Automotors Limited Logo" className='embedded_techimg' />
          <Image img src={Vfb} alt="V-Tech Food and Beverages Logo" className='embedded_techimg' />

          <Image img src={Kipl} alt="Kuntvalli Industries Private Limited Logo" className='embedded_techimg' />
          <Image img src={Sgb} alt="Sri Gowri Bhargava Private Limited Logo" className='embedded_techimg' />
          <Image img src={Sumukha} alt="Sumuka Steels Logo" className='embedded_techimg' />
          <Image img src={Techno} alt="Techno Rings Logo" className='embedded_techimg' />

          <Image img src={Uahs} alt="University of Agriculture and Horticulture Sciences Logo" className='embedded_techimg' />
          <Image img src={Nes} alt="National Education Society Logo" className='embedded_techimg' />
          <Image img src={Jnnce} alt="JNN College of Engineering Logo" className='embedded_techimg' />
          <Image img src={Gfgc} alt="Government First Grade College Logo" className='embedded_techimg' />

          <Image img src={Vishwa} alt="Vishwabhushana Trust Logo" className='embedded_techimg' />
          <Image img src={Amst} alt="AMST Conference Logo" className='embedded_techimg' />
          <Image img src={Clinical} alt="Veterinary college Logo" className='embedded_techimg' />
          <Image img src={Glwc} alt="Rajya Sarkari Padavi Collegegala Atithi Upanyasakara Hitarakshana Samithi Logo" className='embedded_techimg' />

          <Image img src={Supari} alt="Natural Supari Logo" className='embedded_techimg' />
          <Image img src={Malnadkitchen} alt="Malnad Kitchen Logo" className='embedded_techimg' />
          <Image img src={MrMillet} alt="Mr Millet Logo" className='embedded_techimg' />
          <Image img src={Rootsgoods} alt="RootsGoods Logo" className='embedded_techimg' />

          <Image img src={Nano} alt="Nano Source Technologies Logo" className='embedded_techimg' />
          <Image img src={Arshiraj} alt="Aashiraj Logo" className='embedded_techimg' />
          <Image img src={Benz} alt="Mercedes Benz Logo" className='embedded_techimg' />
          <Image img src={Church} alt="St Thomas Church Logo" className='embedded_techimg' />

          <Image img src={Monica} alt="Monica Kulkarni Logo" className='embedded_techimg' />
          <Image img src={Pgp} alt="PG Prashanth Physics Channel Logo" className='embedded_techimg' />
          <Image img src={Scholar} alt="Scholar Monk Foundation Logo" className='embedded_techimg' />
          <Image img src={Cedlabs} alt="CED Labs Logo" className='embedded_techimg' />


      </Carousel>
    </div>


    </div>
  )
}

export default Clients
